import { CSV_HEADERS } from '@domain/constants/csv-headers';
import { CsvDataHelper } from '@domain/interface/data-map';

export const LANE_DATA_MAP = (): CsvDataHelper => ({
	headersMap: [
		{ value: CSV_HEADERS.TRAILER_TYPE, label: 'Trailer Type', required: true },
		{ value: CSV_HEADERS.ORIGIN_CITY, label: 'Origin City', required: true },
		{ value: CSV_HEADERS.ORIGIN_STATE, label: 'Origin State', required: true },
		{ value: CSV_HEADERS.DESTINATION_CITY, label: 'Destination City', required: true },
		{ value: CSV_HEADERS.DESTINATION_STATE, label: 'Destination State', required: true },
		{ value: CSV_HEADERS.MC, label: 'MC', required: true },
		{ value: CSV_HEADERS.DOT, label: 'DOT', required: true },
	],

	requiredHeaders: [
		CSV_HEADERS.TRAILER_TYPE,
		CSV_HEADERS.ORIGIN_CITY,
		CSV_HEADERS.ORIGIN_STATE,
		CSV_HEADERS.DESTINATION_CITY,
		CSV_HEADERS.DESTINATION_STATE,
		CSV_HEADERS.MC,
		CSV_HEADERS.DOT,
	],

	fileDataValidator: function (_, fileData) {
		var alerts = [];

		if (fileData.length > 0) {
			for (var i = 0; i < fileData.length; i++) {
				var line = fileData[i];
				if (!this.isValidLine('lane', line)) {
					alerts.push({ type: 'danger', msg: 'Invalid line' });
					break;
				}
			}
		}

		return alerts;
	},

	formGroupBuilder: () => {},

	fileUploadBucketName: 'cargochief-bulk-lane',
});
